const FiltroIcon = ({ size }) => {
  return (
    <svg
      width={size ? size : "24"}
      height={size ? size : "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7H12"
        stroke="#006299"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M4 17H6"
        stroke="#006299"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M18 7H20"
        stroke="#006299"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M13 17H20"
        stroke="#006299"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 10C16.6569 10 18 8.65685 18 7C18 5.34315 16.6569 4 15 4C13.3431 4 12 5.34315 12 7C12 8.65685 13.3431 10 15 10Z"
        stroke="#006299"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9 20C10.6569 20 12 18.6569 12 17C12 15.3431 10.6569 14 9 14C7.34315 14 6 15.3431 6 17C6 18.6569 7.34315 20 9 20Z"
        stroke="#006299"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
export default FiltroIcon;
